import {
	LOGO_CONTAINER,
	MENU_BIG,
	MENU_SMALL,
	USER_INFO_CONTAINER_BIG,
	USER_INFO_CONTAINER_SMALL,
} from '@constants/menu.contant';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useMenuStyles = makeStyles((theme: Theme) => ({
	root: {
		backgroundColor: theme.palette.primary.main,
		display: 'flex',
		flexFlow: 'column wrap',
		height: '100vh',
		left: 0,
		position: 'fixed',
		top: 0,
		zIndex: 1300,
	},
	rootBig: {
		width: `${MENU_BIG} !important`,
	},
	rootSmall: {
		width: `${MENU_SMALL} !important`,
	},
	logoContainer: {
		height: LOGO_CONTAINER,
		paddingLeft: 12,
		paddingTop: 17 + 24 + 20,
		position: 'relative',
		width: '100%',
	},
	toggleButton: {
		alignItems: 'center',
		backgroundColor: '#1a6bb5',
		border: 'none',
		borderRadius: '4px',
		color: 'white',
		cursor: 'pointer',
		display: 'flex',
		height: 24,
		justifyContent: 'center',
		position: 'absolute',
		right: 24,
		textAlign: 'center',
		top: 17,
		width: 24,
	},
	toggleButtonSmall: {
		right: -7,
	},
	menuContainer: {
		height: `calc(100% - ${LOGO_CONTAINER} - ${USER_INFO_CONTAINER_BIG})`,
		width: '100%',
	},
	menuContainerSmall: {
		height: `calc(100% - ${LOGO_CONTAINER} - ${USER_INFO_CONTAINER_SMALL})`,
	},
	menuItem: {
		alignItems: 'center',
		backgroundColor: 'transparent',
		border: 'none',
		color: 'white',
		cursor: 'pointer',
		display: 'flex',
		height: 53,
		padding: '0 24px',
		width: '100%',
	},
	menuItemActive: {
		backgroundColor: '#3681cd',
		background:
			'transparent linear-gradient(90deg, #086BB5 0%, #5799E891 100%) 0% 0% no-repeat padding-box',
	},
	menuItemIcon: {
		alignItems: 'center',
		display: 'flex',
		height: 24,
		justifyContent: 'center',
		width: 24,
	},
	menuItemTitle: {
		fontSize: '.9rem',
		fontWeight: 500,
		margin: 0,
		marginLeft: '1rem',
		padding: 0,
	},
	userInfoContainer: {
		backgroundColor: 'transparent',
		border: 0,
		cursor: 'pointer',
		height: USER_INFO_CONTAINER_BIG,
		padding: 4,
		textAlign: 'left',
		width: '100%',
		zIndex: 2,
	},
	userInfoContainerSmall: {
		height: USER_INFO_CONTAINER_SMALL,
		padding: 0,
	},
}));

export default useMenuStyles;
